import { lazy } from 'react'

// Doc-heavy modal: defer its code until first open so it isn't parsed or
// committed on the interaction frame that opens it.
export const AccessTokenModal = lazy(() =>
  import('@/shared/components/AccessTokenModal').then((m) => ({ default: m.AccessTokenModal })),
)
export const SupportModal = lazy(() =>
  import('@/shell/SupportModal').then((m) => ({ default: m.SupportModal })),
)
